var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewCheckmarkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.73,
    height: 9.061,
    viewBox: "0 0 11.73 9.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5_Copy",
    "data-name": "Stroke 5 Copy",
    d: "M10.5-.471l-7,8-4-4",
    transform: "translate(0.85 0.8)",
    fill: "none",
    stroke: "#FFFFFF",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheckmarkWhite);
export default __webpack_public_path__ + "static/media/new-checkmark-white.ea0ab1c9ffcf8c662df88b98313641ab.svg";
export { ForwardRef as ReactComponent };